import React, { useEffect, useState } from 'react';
import styles from '../monickieurbanjos/monickieurbanjos.module.scss';
import perfil from '../monickieurbanjos/src/perfil.png';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';

const EMAIL = 'contato@monickie.com.br';
const WHATSAPP_NUMBER = '5511969227016';
const WHATSAPP_MSG = 'Olá! Vim pelo link na bio e gostaria de falar sobre publicidade e parcerias.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;
const TIKTOK_URL = 'https://www.tiktok.com/@monickieurbanjos?_r=1&_t=ZS-99jjn1njMpN';
const TIKTOK_SHOP_URL = 'https://vt.tiktok.com/ZS9SnwwmjjXVW-m3ccN/';
const SHOPEE_URL = 'https://collshp.com/linkeipravoce?view=storefront';
const ICON_COLOR = 'url(#monickie-gold)';

type WorkedBrand = {
    name: string;
    src: string;
    seal?: boolean;
};

const WORKED_BRANDS: WorkedBrand[] = [
    { name: 'MAC', src: require('./src/logos/MAC.png') },
    { name: 'Shiseido', src: require('./src/logos/SHISEIDO.png') },
    { name: 'Maybelline', src: require('./src/logos/MAYBELLINE.png') },
    { name: 'Natura', src: require('./src/logos/NATURA.png') },
    { name: 'C&A', src: require('./src/logos/CEA.png'), seal: true },
    { name: 'Riachuelo', src: require('./src/logos/RIACHUELO.png') },
    { name: 'Bioré', src: require('./src/logos/BIORE.png') },
    { name: 'Principia', src: require('./src/logos/PRINCIPIA.png') },
    { name: 'Océane', src: require('./src/logos/OCEANE.png') },
    { name: 'Simple Organic', src: require('./src/logos/SIMPLE ORGANIC.png') },
];

type ContactCard = {
    id: number;
    image: string;
    brand: string;
    modal: 'contact';
};

type SoonCard = {
    id: number;
    image: string;
    brand: string;
    modal: 'soon';
};

type CupomCard = {
    id: number;
    image: string;
    brand: string;
    cupom?: string;
    desconto?: string;
    site?: string;
    ctaLabel?: string;
    modal: true;
};

type LinkCard = {
    id: number;
    image: string;
    brand: string;
    link: string;
    modal?: false;
};

type ModalCard = ContactCard | SoonCard | CupomCard;
type CardItem = ModalCard | LinkCard;

const PARTNER_CONTACT: ContactCard = {
    id: 0,
    image: '',
    brand: 'Parcerias',
    modal: 'contact',
};

const cardImages: CardItem[] = [
    {
        id: 1,
        image: require('./src/cards/1.png'),
        brand: 'Perfil Tiktok',
        link: TIKTOK_URL,
    },
    {
        id: 2,
        image: require('./src/cards/2.png'),
        brand: 'Vitrine TikTok Shop',
        link: TIKTOK_SHOP_URL,
    },
    {
        id: 3,
        image: require('./src/cards/3.png'),
        brand: 'Vitrine Shopee',
        link: SHOPEE_URL,
    },
    {
        id: 4,
        image: require('./src/cards/4.png'),
        brand: 'Grupo de achados',
        link: 'https://chat.whatsapp.com/DcAu0xi6suIF2aQR1XW1vt?s=cl&p=i&mlu=4&ilr=4'
    },
    {
        id: 5,
        image: require('./src/cards/5.png'),
        brand: 'Saint Germain',
        cupom: 'A-MONICKIEPA',
        site: 'https://www.saintgermainbrand.com.br/',
        modal: true,
    },
    {
        id: 6,
        image: require('./src/cards/6.png'),
        brand: 'Theoric',
        cupom: 'MONI15',
        site: 'https://theoric.com.br/',
        modal: true,
    },
    {
        id: 7,
        image: require('./src/cards/7.png'),
        brand: 'Camicado',
        cupom: 'MONIURBANJOS',
        site: 'https://www.camicado.com.br/',
        modal: true,
    },
    {
        id: 8,
        image: require('./src/cards/8.png'),
        brand: 'Província',
        cupom: 'MONICKIE',
        site: 'https://provincia.casa/',
        modal: true,
    },
    {
        id: 9,
        image: require('./src/cards/9.png'),
        brand: 'Arm Fitness',
        cupom: 'MONICKIE',
        site: 'https://www.armfitness.com.br/',
        modal: true,
    },
    {
        id: 10,
        image: require('./src/cards/10.png'),
        brand: 'Cléa Store',
        link: 'https://s.shopee.com.br/4AzzAHd3qw',
    },
    {
        id: 11,
        image: require('./src/cards/11.png'),
        brand: 'Pure Shower',
        cupom: 'MONICKIE',
        site: 'https://www.pureshower.com.br/moni',
        modal: true,
    },
    {
        id: 12,
        image: require('./src/cards/12.png'),
        brand: 'C&A',
        link: 'https://www.cea.com.br/minhacea/favs?utm_source=mais&utm_medium=minhacea&utm_campaign=favs',
    },
];

const Monickieurbanjos: React.FC = () => {
    const [activeCard, setActiveCard] = useState<ModalCard | null>(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!activeCard) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setActiveCard(null);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [activeCard]);

    useEffect(() => {
        setCopied(false);
    }, [activeCard]);

    const handleCopy = async () => {
        if (!activeCard || activeCard.modal !== true || !activeCard.cupom) return;
        try {
            await navigator.clipboard.writeText(activeCard.cupom);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1800);
        } catch {
            setCopied(false);
        }
    };

    return (
        <div className={styles.monickieurbanjos}>
            <svg className={styles.goldDefs} aria-hidden="true" focusable="false">
                <defs>
                    <linearGradient id="monickie-gold" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#fbe286" />
                        <stop offset="55%" stopColor="#be9b38" />
                        <stop offset="100%" stopColor="#fbe286" />
                    </linearGradient>
                </defs>
            </svg>
            <div className={styles.container}>
                <img src={perfil} alt="Monickie Ürbanjos" className={styles.perfil} />
                <div className={styles.socialRow}>
                    <a
                        href={`mailto:${EMAIL}`}
                        className={styles.socialLink}
                        aria-label="E-mail"
                    >
                        <svg
                            height="24"
                            width="24"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                fill={ICON_COLOR}
                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                            />
                        </svg>
                    </a>
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="WhatsApp"
                    >
                        <WhatsappIcon height="24" color={ICON_COLOR} />
                    </a>
                    <a
                        href={TIKTOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="TikTok"
                    >
                        <TiktokIcon height="22" color={ICON_COLOR} />
                    </a>
                </div>
                <div className={styles.cards}>
                    <button
                        type="button"
                        className={styles.midiaKit}
                        onClick={() => setActiveCard(PARTNER_CONTACT)}
                        aria-label="Vamos trabalhar juntos"
                    >
                        <h2 className={styles.midiaKitTitle}>Vamos trabalhar juntos?</h2>
                        <p className={styles.midiaKitSubtitle}>
                            Parcerias • Publicidade • Tiktok Shop • UGC • Live Shop Host
                        </p>
                    </button>
                    {cardImages.map((card) => {
                        const item =
                            card.modal ? (
                                <button
                                    type="button"
                                    key={card.id}
                                    className={styles.card}
                                    onClick={() => setActiveCard(card)}
                                    aria-label={`Abrir ${card.brand}`}
                                >
                                    <img src={card.image} alt={card.brand} />
                                </button>
                            ) : (
                                <a
                                    href={card.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    key={card.id}
                                    className={styles.card}
                                >
                                    <img src={card.image} alt={card.brand} />
                                </a>
                            );

                        if (card.id !== 5) return item;

                        return (
                            <div key="partner-section" className={styles.partnerBlock}>
                                <div className={styles.sectionHead}>
                                    <span className={styles.sectionLine} aria-hidden />
                                    <div className={styles.sectionCopy}>
                                        <p className={styles.sectionEyebrow}>Cupons</p>
                                        <h2 className={`${styles.sectionTitle} ${styles.sectionTitleGold}`}>
                                            Lojas parceiras
                                        </h2>
                                    </div>
                                    <span className={styles.sectionLine} aria-hidden />
                                </div>
                                {item}
                            </div>
                        );
                    })}
                    <section className={styles.brandsWall} aria-labelledby="monickie-brands-title">
                        <div key="partner-section" className={styles.partnerBlock}>
                            <div className={styles.sectionHead}>
                                <span className={styles.sectionLine} aria-hidden />
                                <div className={styles.sectionCopy}>
                                    <h2 className={`${styles.sectionTitle} ${styles.sectionTitleGold}`}>
                                        Marcas & Collabs
                                    </h2>
                                </div>
                                <span className={styles.sectionLine} aria-hidden />
                            </div>
                        </div>
                        <p className={styles.brandsLead}>
                            MARCAS QUE FAZEM PARTE DESSA HISTÓRIA
                        </p>
                        <img
                            src={require('./src/marcastrabalhadas.png')}
                            alt="Marcas trabalhadas"
                            className="w-100"
                            decoding="async"
                            loading="lazy"
                        />
                        {/* <ul className={styles.brandsVitrine}>
                            {WORKED_BRANDS.map((brand) => (
                                <li key={brand.name} className={styles.brandTile}>
                                    <span
                                        className={
                                            brand.seal
                                                ? `${styles.brandMark} ${styles.brandMarkSeal}`
                                                : styles.brandMark
                                        }
                                    >
                                        <img
                                            src={brand.src}
                                            alt=""
                                            className={
                                                brand.seal
                                                    ? `${styles.brandLogo} ${styles.brandLogoSeal}`
                                                    : styles.brandLogo
                                            }
                                            decoding="async"
                                            loading="lazy"
                                        />
                                    </span>
                                    <span className={styles.brandName}>{brand.name}</span>
                                </li>
                            ))}
                        </ul> */}
                    </section>
                </div>
            </div>

            {activeCard && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setActiveCard(null)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="monickieurbanjos-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setActiveCard(null)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>

                        <p className={styles.modalEyebrow}>
                            {activeCard.modal === 'contact'
                                ? 'Parcerias'
                                : activeCard.modal === 'soon'
                                    ? 'Em breve'
                                    : activeCard.cupom
                                        ? 'Cupom exclusivo'
                                        : 'Oferta exclusiva'}
                        </p>
                        <h2 id="monickieurbanjos-modal-title" className={styles.modalBrand}>
                            {activeCard.brand}
                        </h2>

                        {activeCard.modal === 'contact' ? (
                            <div className={styles.contactActions}>
                                <a href={`mailto:${EMAIL}`} className={styles.contactBtnEmail}>
                                    <svg
                                        height="22"
                                        width="22"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-hidden="true"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                                        />
                                    </svg>
                                    <span>E-mail</span>
                                </a>
                                <a
                                    href={WHATSAPP_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.contactBtnWhatsapp}
                                >
                                    <WhatsappIcon height="22" color="currentColor" />
                                    <span>WhatsApp</span>
                                </a>
                            </div>
                        ) : activeCard.modal === 'soon' ? (
                            <div className={styles.cupomBoxEmpty}>
                                <span className={styles.cupomEmptyText}>
                                    Este conteúdo estará disponível em breve.
                                </span>
                            </div>
                        ) : (
                            <>
                                {activeCard.cupom ? (
                                    <div className={styles.cupomBox}>
                                        <span className={styles.cupomLabel}>Seu cupom</span>
                                        <span className={styles.cupomCode}>{activeCard.cupom}</span>
                                        {activeCard.desconto ? (
                                            <span className={styles.cupomDesconto}>{activeCard.desconto}</span>
                                        ) : null}
                                        <button
                                            type="button"
                                            className={styles.copyBtn}
                                            onClick={handleCopy}
                                        >
                                            {copied ? 'Copiado!' : 'Copiar cupom'}
                                        </button>
                                    </div>
                                ) : activeCard.desconto ? (
                                    <div className={styles.cupomBox}>
                                        <span className={styles.cupomLabel}>Desconto</span>
                                        <span className={styles.cupomCode}>{activeCard.desconto}</span>
                                    </div>
                                ) : (
                                    <div className={styles.cupomBoxEmpty}>
                                        <span className={styles.cupomLabel}>Cupom</span>
                                        <span className={styles.cupomEmptyText}>
                                            Em breve um cupom exclusivo para você
                                        </span>
                                    </div>
                                )}

                                {activeCard.site ? (
                                    <a
                                        href={activeCard.site}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={styles.siteBtn}
                                    >
                                        {activeCard.ctaLabel ?? 'Ir para o site'}
                                    </a>
                                ) : null}
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Monickieurbanjos;
